<ng-container *ngIf="state$ | async as state">
  @if (state.view; as view) {
    <div class="copilot-pane__body px-3 pt-2 pb-3 font-13">
      @if (view.insight; as insight) {
        <!-- The signals of the insight, then the accordion of its sections (prototype D). -->
        <div class="d-flex flex-wrap align-items-center gap-1 pb-2 border-bottom">
          <span class="badge campaign-badge" [ngClass]="tone(insight.content.relationship.sentiment.value)">
            {{ "attendance.copilot.insight.value." + insight.content.relationship.sentiment.value | translate }}
            {{ arrow(insight.content.relationship.sentiment.trend) }}
          </span>
          <span class="badge campaign-badge" [ngClass]="tone(insight.content.relationship.churnRisk.level)">
            <span class="campaign-badge-dot"></span>{{ riskKey(view) | translate }}
          </span>
          <span class="badge campaign-badge" [ngClass]="tone(insight.content.relationship.health.band)">
            {{ "attendance.copilot.summary.health" | translate: { score: insight.content.relationship.health.score } }}
          </span>
          <small class="text-muted ms-auto">
            {{
              generatedKey(insight.generatedAt)
                | translate
                  : {
                      date: (insight.generatedAt | timezoneDate: "DD/MM" : timezone),
                      time: (insight.generatedAt | timezoneDate: "HH:mm" : timezone),
                    }
            }}
          </small>
        </div>
      }

      @if (!closed(view) && !view.insight) {
        @if (view.state === "failed") {
          <div class="alert alert-warning py-2 mb-2" role="alert">
            <p class="mb-0">
              <i class="ri-error-warning-line me-1"></i>{{ "attendance.copilot.insight.generateFailed" | translate }}
            </p>
          </div>
          <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="state.requesting" (click)="generate()">
            <i class="ri-refresh-line"></i>
            {{ "attendance.copilot.insight.generate" | translate }}
          </button>
        } @else if (!generating(state)) {
          <p class="text-muted mb-0">{{ waitingKey(view) | translate: { n: view.waiting?.n } }}</p>
        }
      }

      @if (generating(state)) {
        <copilot-thinking-indicator class="d-block mt-2" action="insight" [phrases]="[progressKey(state)]" />
      }

      @if (state.requestFailed && !closed(view)) {
        <div class="alert alert-warning py-2 mt-2 mb-0" role="alert">
          <p class="mb-0">
            <i class="ri-error-warning-line me-1"></i>{{ "attendance.copilot.insight.updateFailed" | translate }}
          </p>
        </div>
      }

      @if (view.insight; as insight) {
        <attendance-copilot-insight-content [content]="insight.content" [timezone]="timezone" />
      }
    </div>

    @if (view.insight; as insight) {
      @if (!closed(view)) {
        <footer class="copilot-pane__footer d-flex align-items-center justify-content-between gap-2 px-3 py-2 border-top font-13">
          <small class="text-muted">
            {{
              footerKey(insight.generatedAt)
                | translate
                  : {
                      date: (insight.generatedAt | timezoneDate: "DD/MM" : timezone),
                      time: (insight.generatedAt | timezoneDate: "HH:mm" : timezone),
                    }
            }}
            @if (state.newMessages > 0) {
              <span>· {{ newMessagesKey(state.newMessages) | translate: { count: state.newMessages } }}</span>
            }
          </small>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary text-nowrap"
            [disabled]="!canUpdate(state)"
            [matTooltip]="canUpdate(state) ? null : ('attendance.copilot.insight.updateHint' | translate)"
            matTooltipPosition="above"
            (click)="generate()"
          >
            @if (!generating(state)) {
              <i class="ri-refresh-line"></i>
            } @else {
              <mat-spinner class="d-inline-block align-middle" [diameter]="14" mode="indeterminate" />
            }
            {{ "attendance.copilot.insight.update" | translate }}
          </button>
        </footer>
      }
    }
  }
</ng-container>
